/**
 * Test Harness Page for P&L Panel (F004)
 *
 * URL params:
 * - periodId: single period ID
 * - periodIds: comma-separated period IDs for multi-period view
 * - mode: 'simplified' or 'detailed'
 */

import React, { useState, useEffect } from 'react';
import { ProfitLossPanel } from '@/components/financial/panels/profit-loss-panel';

export const FinancialPlPanelTestPage: React.FC = () => {
  const [periodIds, setPeriodIds] = useState<string[]>([]);
  const [mode, setMode] = useState<'simplified' | 'detailed'>('simplified');

  useEffect(() => {
    // Parse URL params from window.location (wouter v3 strips query strings)
    const params = new URLSearchParams(window.location.search);
    const singlePeriodId = params.get('periodId');
    const multiplePeriodIds = params.get('periodIds');
    const urlMode = params.get('mode') as 'simplified' | 'detailed' | null;

    if (singlePeriodId) {
      setPeriodIds([singlePeriodId]);
    } else if (multiplePeriodIds) {
      setPeriodIds(multiplePeriodIds.split(','));
    }

    if (urlMode) {
      setMode(urlMode);
    }
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">P&L Panel Test Harness</h1>

      {/* Mode toggles */}
      <div className="mb-4 flex gap-2">
        <button
          data-testid="mode-toggle-simplified"
          aria-pressed={mode === 'simplified'}
          onClick={() => setMode('simplified')}
          className={`px-4 py-2 rounded ${
            mode === 'simplified' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          }`}
        >
          Simplified
        </button>
        <button
          data-testid="mode-toggle-detailed"
          aria-pressed={mode === 'detailed'}
          onClick={() => setMode('detailed')}
          className={`px-4 py-2 rounded ${
            mode === 'detailed' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          }`}
        >
          Detailed
        </button>
      </div>

      {periodIds.length > 0 ? (
        <ProfitLossPanel periodIds={periodIds} mode={mode} />
      ) : (
        <p className="text-gray-500">No period IDs provided</p>
      )}
    </div>
  );
};
